import {
  TenantEntityOperationApi,
  TenantIntegrationConnectionStatus,
  TenantIntegrationConnectionStatusDetailsDTO,
  TenantIntegrationType,
} from '@recurrency/core-api-schema/dist/tenants/tenantUserDTO';

import { camelToTitleCase } from 'utils/formatting';

export interface ConnectionStatus {
  integration: string;
  operations: string[];
  status: TenantIntegrationConnectionStatus;
  error?: string;
}

export function getConnectionStatuses(
  connectionStatusDetails: TenantIntegrationConnectionStatusDetailsDTO,
): ConnectionStatus[] {
  const { connectionStatus, connectionApi, error } = connectionStatusDetails;
  if (error) return [];

  const integrationToOperations: Record<TenantIntegrationType, TenantEntityOperationApi[]> = {
    [TenantIntegrationType.DirectSql]: [],
    [TenantIntegrationType.P21CloudApi]: [],
    [TenantIntegrationType.P21Sism]: [],
    [TenantIntegrationType.P21TransactionApi]: [],
    [TenantIntegrationType.P21InteractiveApi]: [],
    [TenantIntegrationType.NetsuiteRestApi]: [],
    [TenantIntegrationType.NetsuiteRestletApi]: [],
    [TenantIntegrationType.Sapb1ServiceLayerApi]: [],
    [TenantIntegrationType.S3Csv]: [],
  };

  const integrationTypeLabels: Record<TenantIntegrationType, string> = {
    [TenantIntegrationType.DirectSql]: 'Direct SQL',
    [TenantIntegrationType.P21CloudApi]: 'P21 Cloud',
    [TenantIntegrationType.P21Sism]: 'P21 SISM',
    [TenantIntegrationType.P21TransactionApi]: 'P21 Transaction',
    [TenantIntegrationType.P21InteractiveApi]: 'P21 Interactive',
    [TenantIntegrationType.NetsuiteRestApi]: 'NS Rest',
    [TenantIntegrationType.NetsuiteRestletApi]: 'NS Restlet',
    [TenantIntegrationType.Sapb1ServiceLayerApi]: 'SB1 Service Layer',
    [TenantIntegrationType.S3Csv]: 'S3 CSV',
  };

  const operationLabels: Record<TenantEntityOperationApi, string> = {
    [TenantEntityOperationApi.DataSync]: 'Data Sync',
    [TenantEntityOperationApi.ExportPurchaseOrder]: 'PO',
    [TenantEntityOperationApi.ExportPurchaseOrderLinking]: 'PO Link',
    [TenantEntityOperationApi.ExportTransferOrder]: 'TO',
    [TenantEntityOperationApi.ExportMinMax]: 'Min/Max',
  };

  const operations = Object.keys(connectionApi) as TenantEntityOperationApi[];
  for (const operation of operations) {
    const integration = connectionApi[operation];
    if (integration && integrationToOperations[integration]) integrationToOperations[integration].push(operation);
  }

  const integrations = Object.keys(connectionStatus) as TenantIntegrationType[];
  const result: ConnectionStatus[] = [];
  for (const integration of integrations) {
    const statusInfo = connectionStatus[integration];
    if (statusInfo) {
      result.push({
        integration: integrationTypeLabels[integration] ?? camelToTitleCase(integration),
        operations: (integrationToOperations[integration] || []).map((v) => operationLabels[v] ?? camelToTitleCase(v)),
        status: statusInfo.status,
        error: statusInfo.error,
      });
    }
  }

  return result;
}
